import { render, staticRenderFns } from "./DescriptionSheet.vue?vue&type=template&id=26c574c3&scoped=true&"
import script from "./DescriptionSheet.vue?vue&type=script&lang=js&"
export * from "./DescriptionSheet.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionSheet.vue?vue&type=style&index=0&id=26c574c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c574c3",
  null
  
)

export default component.exports